import React from "react";
import styles from "../../styles/FaqPageStyle.module.css";
import { Card, CardBody, Collapse } from "reactstrap";
import { useState } from "react";
import { AiOutlinePlusCircle, AiOutlineMinusCircle } from "react-icons/ai";
import Question from "../../assets/imgs/EF Branding Website/334731_quora_icon.png";
import Answer from "../../assets/imgs/EF Branding Website/letter-a (1).png";
const QuesFive = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };
  return (
    <div>
      <div className="d-flex justify-content-center align-items-center">
        <img src={Question} alt="" style={{ width: "30px", height: "30px" }} />
        <button id="toggler5" className={styles.btn} onClick={toggle}>
          <span style={{ textAlign: "left" }}> What are our clients' cargo types?</span>
         
          {!isOpen ? (
            <div className={styles.icon_container}>
              <AiOutlinePlusCircle className={styles.icon} />
            </div>
          ) : (
            <div className={styles.icon_container}>
              <AiOutlineMinusCircle className={styles.icon} />
            </div>
          )}
        </button>
      </div>
      <Collapse isOpen={isOpen}>
        <div className="d-flex mt-3">
          <img src={Answer} alt="" className={styles.img} />
          <Card style={{ width: "100%" }}>
            <CardBody>
              <ul>
                <li className="mb-2">Wifi Companies</li>
                <li className="mb-2">Electronic Companies</li>
                <li className="mb-2">Kitchenware Accessories Wholesaler</li>
                <li className="mb-2">Phone Accessories Wholesaler</li>
                <li className="mb-2">Heavy Machine Industries</li>
                <li className="mb-2">Spare parts & Tools Suppliers</li>
                <li className="mb-2">Pet Accessories Suppliers</li>
                <li className="mb-2">Fabric & Clothing Wholesaler</li>
                <li className="mb-2">
                  Home Decoration & Construction Materials
                </li>
                <li className="mb-2">Bags/Shoes and Fancy Wholesaler</li>
                <li className="mb-2">Cosmetics Wholesaler</li>
                <li className="mb-2">Garment Factories</li>
                <li className="mb-2">Sports & Gym equipments</li>
                <li className="mb-2">Dental Clinics</li>
                <li className="mb-2">Medical Equipment</li>
                <li className="mb-2">Supplier</li>
                <li className="mb-2">Media & Advertising Companies</li>
                <li className="mb-2">Tire & Battery Distributors</li>
                <li className="mb-2">Printer & Copier Distributors</li>
              </ul>
            </CardBody>
          </Card>
        </div>
      </Collapse>
    </div>
  );
};
export default QuesFive;
